/* eslint-disable i18next/no-literal-string */
import { InputAdornment } from 'ui';

import { TextField, TextFieldProps } from '../TextField/TextField';

export type PercentageFieldProps = Omit<TextFieldProps, 'type'>;

export const PercentageField = ({ rules = {}, ...rest }: PercentageFieldProps) => {
  const htmlInputSlotProps = typeof rest.slotProps?.htmlInput === 'object' ? rest.slotProps.htmlInput : {};
  const inputSlotProps = typeof rest.slotProps?.input === 'object' ? rest.slotProps.input : {};

  return (
    <TextField
      type="number"
      {...rest}
      slotProps={{
        ...rest.slotProps,
        htmlInput: {
          max: 100,
          min: 0,
          ...htmlInputSlotProps,
        },
        input: {
          endAdornment: <InputAdornment position={'end'}>%</InputAdornment>,
          ...inputSlotProps,
        },
      }}
      rules={{
        max: { message: 'Value must be at most 100', value: 100 },
        min: { message: 'Value must be at least 0', value: 0 },
        ...rules,
      }}
      sx={{
        minWidth: 82,
      }}
    />
  );
};
